import React from "react";
import TextField from "@material-ui/core/TextField";

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

export class FileInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = { fileName: "" };
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    const {
      input: { onChange }
    } = this.props;
    const imgFile = e.target.files[0];
    this.setState({ fileName: imgFile.name });
    getBase64(imgFile).then(pic => {
      onChange(pic);
    });
  }

  render() {
    const {
      input,
      label,
      meta: { touched, error },
      ...custom
    } = this.props;

    return (
      <>
        <TextField
          InputProps={{
            readOnly: true
          }}
          {...input}
          {...custom}
          label="Avatar"
          value={this.state.fileName || input.value}
        />
        <input
          type="file"
          onChange={this.onChange}
          id="avatar-file-input"
          hidden
        />
        &nbsp; &nbsp;
      </>
    );
  }
}
